export function openFeedbackDialog() {
  window.dispatchEvent(new CustomEvent('retiora:open-feedback'))
}
